/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
import { WidgetEditorContext } from '../WidgetEditorContext';
export const WidgetComponent = React.memo((props) => {
    const widgetEditorContext = React.useContext(WidgetEditorContext);
    const errorMessage = `Error occurred in ${props.widget.type}`;
    if (widgetEditorContext.editMode && props.widget.editorComponent) {
        return React.createElement(ErrorBoundary, { errorMessage: errorMessage }, React.createElement(props.widget.editorComponent, props));
    }
    else {
        return React.createElement(ErrorBoundary, { errorMessage: errorMessage }, React.createElement(props.widget.component, props));
    }
}, (prevProps, nextProps) => {
    return prevProps.renderCounter === nextProps.renderCounter && prevProps.config === nextProps.config;
});
